function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import Collection from './collection';
import activityFactory from '../activity_factory';
/*
 * A heterogenious collection of activities (polls and surveys)
 */

var ActivityCollection = /*#__PURE__*/function (_Collection) {
  _inheritsLoose(ActivityCollection, _Collection);

  function ActivityCollection() {
    return _Collection.apply(this, arguments) || this;
  }

  var _proto = ActivityCollection.prototype;

  _proto.preinitialize = function preinitialize() {
    //  Default comparator is by position
    this.comparator = 'position';
  }
  /*
   * @param [Model|Array] models Backbone takes one model or an array of models
   * @param [Object] options
   * @option options [Number] group_id Associate this collection to a group-this passes the `group_id` as a param when fetching
   * @option options [Number] user_id Associate this collection to a user-this passes the `user_id` as a param when fetching
   *
   */
  ;

  _proto.initialize = function initialize(models, options) {
    if (models === void 0) {
      models = [];
    }

    if (options === void 0) {
      options = {};
    }

    this.group_id = options.group_id;
    this.user_id = options.user_id;
  }
  /*
   * @param [Object] options Basic Bacbone option for a collection.fetch
   * @note By default, the `options.group_id`, and `options.user_id` will be the group that initialized this collection.
   */
  ;

  _proto.fetch = function fetch(options) {
    if (options === void 0) {
      options = {};
    }

    _.defaults(options, {
      data: {}
    });

    _.defaults(options.data, {
      group_id: this.group_id,
      user_id: this.user_id
    });

    return _Collection.prototype.fetch.call(this, options);
  }
  /*
   * Build an activity from the attributes
   *
   * @param [Object] attrs Model attributes
   * @param [Object] options Model options
   *
   * @return [Model]
   *
   */
  ;

  _proto.model = function model(attrs, options) {
    return activityFactory(attrs, options);
  }
  /*
   * Compute the id `:type_:id` for the heterogenious models
   *
   * @param [Object] attrs Attributes
   *
   * @return [String] `:type_:id` or null if uncomputable
   *
   */
  ;

  _proto.modelId = function modelId(attrs) {
    if (attrs === void 0) {
      attrs = {};
    }

    var _attrs = attrs,
        id = _attrs.id,
        type = _attrs.type;

    if (id && type) {
      return type + "_" + id;
    } else {
      return null;
    }
  }
  /*
   * Get a model by its computed id or model id and type
   *
   * @overload get(id)
   *   Get a model by its computed id from `#modelId()` method
   *   @param [String] id Computed id
   *   @return [Model]
   *
   * @overload get(id, type)
   *   Get a model by its id and type
   *   @param [Integer] id Model ID
   *   @param [String] type Model type
   *   @return [Model]
   *
   */
  ;

  _proto.get = function get(id, type) {
    if (type != null) {
      return this.findWhere({
        type: type,
        id: id
      });
    } else {
      return _Collection.prototype.get.apply(this, arguments);
    }
  };

  _createClass(ActivityCollection, [{
    key: "url",
    get: function get() {
      return '/api/activities';
    }
  }]);

  return ActivityCollection;
}(Collection);

export { ActivityCollection as default };